import { FILTER_NAMES, TRANSLATABLE_FILTER_NAMES } from "shared/types/enums";

const alphabeticalSort = [
    FILTER_NAMES.AccessGroup,
    FILTER_NAMES.ConfigurationFileId,
    FILTER_NAMES.CurrentCfg,
    FILTER_NAMES.CurrentFw,
    FILTER_NAMES.GroupId,
    FILTER_NAMES.Model,
    FILTER_NAMES.ModelPlatform,
    FILTER_NAMES.Origin,
    FILTER_NAMES.SpecId,
    TRANSLATABLE_FILTER_NAMES.ConfigurationChangeType,
    TRANSLATABLE_FILTER_NAMES.FileType
];

export { alphabeticalSort };
